import type { InspectionItemResult } from "../../domain/types";

const OPTIONS: Array<{ value: Exclude<InspectionItemResult, null>; label: string; hint: string }> = [
  { value: "pass", label: "Pass", hint: "No change" },
  { value: "attention", label: "Attention", hint: "Flag + note" },
  { value: "fail", label: "Fail", hint: "Unsafe / blocked" }
];

const toneClasses: Record<Exclude<InspectionItemResult, null>, { base: string; selected: string }> = {
  pass: { base: "border-success text-success", selected: "bg-success text-success-foreground border-success" },
  attention: { base: "border-attention text-attention", selected: "bg-attention text-attention-foreground border-attention" },
  fail: { base: "border-danger text-danger", selected: "bg-danger text-danger-foreground border-danger" }
};

/** The Direction C instrument capture control — large, unambiguous, never color-only (label + icon always present). */
export function PassAttnFail({
  value,
  onChange
}: {
  value: InspectionItemResult;
  onChange: (result: Exclude<InspectionItemResult, null>) => void;
}) {
  return (
    <div role="radiogroup" aria-label="Inspection result" className="grid grid-cols-3 gap-2">
      {OPTIONS.map((opt) => {
        const selected = value === opt.value;
        const tones = toneClasses[opt.value];
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(opt.value)}
            className={`touch-target flex min-h-[84px] flex-col items-center justify-center gap-1 rounded-md border-2 font-action text-base font-bold transition-colors ${
              selected ? tones.selected : `bg-card ${tones.base}`
            }`}
          >
            <span>{opt.label}</span>
            <span className="font-mono text-[9px] font-semibold uppercase tracking-wide opacity-80">{opt.hint}</span>
          </button>
        );
      })}
    </div>
  );
}
